/**
 * @const {object}
 * @memberOf module:Employees
 */
export const employeesTraining = {
    /* @ngInject */
    controller: function ($ngRedux) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(({ employees }) => ({
                employee: employees.employeeDetails
            }), {
                //actions
            })(this);

            this.loading = false;
        }

        this.$onDestroy = () => {
            this.loading = false;
        }
    },
    template: require('./employees-training.html'),
    bindings: {
        userUuid: '@'
    },
};
